import { useCurrentUserAccessRole } from "Hooks/useCurrentUserAccessRole";
import { AccessRoleCodes } from "Models/AccessRoleCodes";

export const useIsCurrentUserEmployee = () =>
  useCurrentUserAccessRole() === AccessRoleCodes.Employee;
